// extracted by mini-css-extract-plugin
export var columnList = "_cv-0";